// components/GlobalMessage.js
import React from 'react';
import ReactDOM from 'react-dom';
import { useMessage } from '../contexts/MessageContext';
import Message from './Message';

const GlobalMessage = () => {
  const { message, hideMessage } = useMessage();

  if (!message.visible) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed left-1/2 -translate-x-1/2 z-[1400] w-[min(92vw,780px)] px-2"
      style={{ top: 'calc(env(safe-area-inset-top, 0px) + 118px)' }}
    >
      <Message
        type={message.type}
        message={message.text}
        onClose={hideMessage}
        autoClose={false}
      />
    </div>,
    document.body
  );
};

export default GlobalMessage;